import { API } from "./API";
export const UserManagementAPI = {
  
    GetUserGroupAdmin2FA: async (clusterId) => {

        let data = JSON.stringify({
            requestValue: {               
                clusterId : clusterId,               
            },
        })   
        return await API.post(`UserManagement/GetUserGroupAdmin2FA`, data);
    },

    GetUserGroupAdmin2FAList: async (groupEuId) => {

        let data = JSON.stringify({
            requestValue: {
                groupEuId: groupEuId,
            },
        })
  
        return await API.post(`UserManagement/GetUserGroupAdmin2FAList`, data);
    },

    InsertUserGroupAdmin2FA: async (groupEuId, name, surname, phone, email) => {

        let data = JSON.stringify({
            requestValue: {               
                groupEuId: groupEuId,
                name: name,
                surname: surname,
                phone: phone,
                email: email
            },
        })
       
        return await API.post(`UserManagement/InsertUserGroupAdmin2FA`, data);
    },

    UpdateUserGroupAdmin2FA: async (clusterId, groupEuId, name, surname, phone, email) => {

        let data = JSON.stringify({
            requestValue: {
                clusterId: clusterId,
                groupEuId: groupEuId,
                name: name,
                surname: surname,
                phone: phone,
                email: email
            },
        })
  
        return await API.post(`UserManagement/UpdateUserGroupAdmin2FA`, data);
    },

     DeleteUserGroupAdmin2FA: async (clusterId) => {

        let data = JSON.stringify({
            requestValue: {
                clusterId: clusterId,               
            },
        })
        return await API.post(`UserManagement/DeleteUserGroupAdmin2FA`, data);
    },

    GetLinks: async (right, groupId) => {

        let data = JSON.stringify({
            requestValue: {
                right: right,       
                groupId: groupId        
            },
        })
        return await API.post(`UserManagement/GetLinks`, data);
    },
   
}